import { render } from "./ApproveLeaveView.vue?vue&type=template&id=1b0fcb95"
import script from "./ApproveLeaveView.vue?vue&type=script&lang=js"
export * from "./ApproveLeaveView.vue?vue&type=script&lang=js"

import "./ApproveLeaveView.vue?vue&type=style&index=0&id=1b0fcb95&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__